import { AccordionDetails } from '@mui/material';

import styled from 'styled-components';

import { Constants } from '@arrived/common';

export const PortfolioAccordionDetails = styled(AccordionDetails)`
  &.MuiAccordionDetails-root {
    background-color: ${({ theme }) => theme.palette.neutrals.milk};
    border-radius: ${({ theme }) => theme.spacing(0, 0, 1, 1)};
    border-top: 1px solid ${({ theme }) => theme.palette.neutrals.platinum};
    padding: ${({ theme }) => theme.spacing(0, 2, 2, 0)};
  }
`;
